import styled, { css } from "styled-components";
import { breakpoints, buildColor } from "@tvg/design-system";

export const Item = styled.li<{
  isFirstOpenRace: boolean;
  isActive: boolean;
  hasPromo: boolean;
  isOptIn: boolean;
  borderWidth: number;
}>`
  min-width: 48px;
  height: 44px;
  flex-grow: 1;
  position: relative;
  scroll-margin-right: 50px;
  scroll-margin-left: 50px;
  ${({ isFirstOpenRace, borderWidth }) =>
    isFirstOpenRace &&
    css`
      border-left: ${borderWidth}px solid ${buildColor("white", "200")};
    `};
  ${({ isActive, borderWidth }) =>
    isActive &&
    css`
      background-color: ${buildColor("white", "200")};
      border-bottom: ${borderWidth}px solid ${buildColor("white", "900")};
    `};
  ${({ borderWidth }) => css`
    &:active {
      background-color: ${buildColor("white", "200")};
      border-bottom: ${borderWidth}px solid ${buildColor("white", "900")};
    }
  `}

  &:active::before {
    background-color: ${buildColor("white", "200")};
  }

  &:hover {
    background-color: ${buildColor("white", "100")};
  }

  ${({ hasPromo, isOptIn }) =>
    (hasPromo || isOptIn) &&
    css`
      &::before {
        content: "";
        position: absolute;
        top: 0;
        width: 33%;
        left: 50%;
        transform: translateX(-50%);
        height: 2px;
        background-color: ${buildColor(isOptIn ? "green" : "yellow", "500")};
        border-radius: 0 0 4px 4px;
      }
    `}

  @media ${breakpoints.tablet.max.sm} {
    flex-grow: 0;

    &:last-child {
      border-radius: 0 4px 4px 0;
      overflow: hidden;
    }
  }
`;

export const RaceNumberWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 6px;
`;
